"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTextMatch = exports.parseRef = exports.isInverse = exports.escapeRegExp = void 0;
const Logger_1 = __importDefault(require("./Logger"));
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
exports.escapeRegExp = escapeRegExp;
const isMatchAll = (text) => text === ".*";
const isRegExp = (exp) => new RegExp(`[${(0, exports.escapeRegExp)("*+|()[]")}]`).test(exp);
function isInverse(text) {
    const result = text.startsWith("!");
    return result ? [result, text.substring(1)] : [result, text];
}
exports.isInverse = isInverse;
function parseRef(text, refData) {
    if (refData != null && text.startsWith("$")) {
        const refValue = refData[text.substring(1)];
        if (refValue != null) {
            return [true, refValue];
        }
    }
    return [false, text];
}
exports.parseRef = parseRef;
function isTextMatch(iPlain, iPattern) {
    const [inversePlain, plain] = isInverse(iPlain);
    const [inversePattern, pattern] = isInverse(iPattern);
    let result = false;
    if (isMatchAll(pattern)) {
        result = true;
    }
    else if (isRegExp(pattern)) {
        try {
            result = new RegExp(`^${pattern}$`, "i").test(plain);
        }
        catch (e) {
            Logger_1.default.error("Invalid RegExp", e);
        }
    }
    if (!result) {
        result = plain === pattern;
    }
    return inversePlain === inversePattern ? result : !result;
}
exports.isTextMatch = isTextMatch;
